export const ENV_CONFIG = {
  // Ở môi trường dev (import.meta.env.DEV), ưu tiên VITE_BACKEND_BASE_URL (https://localhost:7200).
  // Khi build/production, ưu tiên window.env (public/config.js) để runtime config theo server thật.
  VITE_BACKEND_BASE_URL:
    (import.meta.env.DEV
      ? import.meta.env.VITE_BACKEND_BASE_URL || window.env?.API_URL
      : window.env?.API_URL || import.meta.env.VITE_BACKEND_BASE_URL) || '',
  SIGN_APP_DOWNLOAD_URL: window.env?.SIGN_APP_DOWNLOAD_URL || '',
  SIGN_APP_PROTOCOL: window.env?.SIGN_APP_PROTOCOL || 'vbdt-sign://',
  TURNSTILE_SITE_KEY:
    window.env?.TURNSTILE_SITE_KEY || import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
  DEBOUNCE_SEARCH: Number(window.env?.DEBOUNCE_SEARCH) || 400,
  TABLE_CELL_MAX_LENGTH: Number(window.env?.TABLE_CELL_MAX_LENGTH) || 50,
  TABLE_CELL_MAX_WIDTH: Number(window.env?.TABLE_CELL_MAX_WIDTH) || 260,
}
